module.exports = __webpack_public_path__ + "static/img/bridge-text-3.cfaa56c5.png";